<template>
    <div>
        <div>
            <div class="d-flex question mb-2">
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <b-list-group>
            <b-list-group-item v-for="(item, index) in question.content.options" :key="index">
                <div v-if="item.type == 'text'">
                    {{item.text}}
                </div>
                <div v-if="item.type == 'image'" :class="{'merlin-asset-border': isMerlinMedia(item.image)}">
                    <div v-if="isMerlinMedia(item.image)" class="merlin-asset-wrapper">
                        <span class="merlin-asset-warning">
                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                            Merlin Asset
                        </span>
                    </div>
                    <b-img
                        :src="item.image"
                        class="p-0"
                        height="100"
                        width="auto"
                        thumbnail
                    />
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    methods: {
        isMerlinMedia(image) {
            return image.toLowerCase().includes('merlinone')
        },
    }
}
</script>
